import * as React from 'react';
import { connect } from 'react-redux';

import { ApplicationState } from '../../store';
import * as JobsStore from '../../store/jobs';

import { JobStatus } from '@components/jobs/JobStatus';

export default connect(
    (state: ApplicationState) => ({
        users: state.user.work?.users ?? [],
        ...JobsStore.plainActions,
        moduleManager: state.modules.moduleManager,
    }),
    JobsStore.actionCreators,
)(JobStatus as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
